module.exports = __webpack_public_path__ + "img/preview.430c23d3.svg";